
const category_menus = document.querySelectorAll('.category-list a, .trim-category-label, .breadcrumb__link, .breadcrumb__notlink');

category_menus.forEach((item, i) => {
  item.innerText = item.innerText.replace('Category: ','');
});
